export const REGEX_DIGIT = new RegExp(/^\d+$/);
export const REGEX_ALPHANUMERIC = new RegExp(/^[a-zA-Z0-9]+$/);
export const REGEX_ALPHANUMERIC_WITH_SPACE = new RegExp(/^[a-zA-Z0-9 ]+$/);
export const REGEX_INTERNATIONAL_ALPHANUMERIC = new RegExp(/^[\p{L}0-9]+$/u);
export const REGEX_INTERNATIONAL_ALPHANUMERIC_WITH_SPACE = new RegExp(/^[\p{L}0-9 ]+$/u);
export const REGEX_INTERNATIONAL_ALPHABETIC = new RegExp(/^[\p{L} ,.'-]+$/u);
export const REGEX_PHONE = new RegExp(
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/
);

export default {
  baseUrl: 'https://api.vetamerikan.org',
  siteUrl: 'https://portal.vetamerikan.org',
  tokenUrl: 'https://portal.vetamerikan.org/base/token.json',
  imagePath: 'https://kochealthcare.blob.core.windows.net/',
  reCaptchaSiteKey: '',
  meetUrl: '',
  storeUrl: {
    vet: {
      iOS: 'https://apps.apple.com/us/app/vetamerikan/id6447752969',
      android: 'https://play.google.com/store/apps/details?id=com.vetamerikan&pli=1',
    },
    khc: {
      iOS: 'https://itunes.apple.com/tr/app/connect-vkv-health/id1145461906',
      android: 'https://play.google.com/store/apps/details?id=com.amerikanhastanesi.connect',
    },
  },
  applicationCode: 'APP02',
  applicationId: '2',
  periodTypes: {
    // period type sabitleri backend tarafından kullanılıyor, ortam bağımsız olarak iletildi.
    MONTHLY: 2,
    YEARLY: 3,
  },
};
